import { initializeApp } from 'firebase/app';
import { getMessaging, isSupported } from 'firebase/messaging';
import { PUBLIC_ENV } from '$env/static/public';

// Firebase API keys are safe to expose in client-side code - they only identify the project
export const productionFirebaseConfig = {
  apiKey: 'AIzaSyD7NWHjeM47nsZR8GIQedLJ4sFJ9rXe9Xo',
  authDomain: 'metri-684c3.firebaseapp.com',
  projectId: 'metri-684c3',
  storageBucket: 'metri-684c3.firebasestorage.app',
  messagingSenderId: '979165218157',
  appId: '1:979165218157:web:a421d31b5fe5954dd08664',
  measurementId: 'G-1BWRFSG3TD',
};

const stagingFirebaseConfig = {
  apiKey: 'AIzaSyBWg6vyr098vKz7ncmyQMm47MesoGUjNcU',
  authDomain: 'metri-staging.firebaseapp.com',
  projectId: 'metri-staging',
  storageBucket: 'metri-staging.firebasestorage.app',
  messagingSenderId: '619537342689',
  appId: '1:619537342689:web:964db5b0abd0df7aa217a0',
};

export const firebaseConfig =
  PUBLIC_ENV === 'production' ? productionFirebaseConfig : stagingFirebaseConfig;

const app = initializeApp(firebaseConfig);

let messaging: ReturnType<typeof getMessaging> | null = null;

const initializeMessaging = async () => {
  const supported = await isSupported();

  if (supported && typeof window !== 'undefined') {
    try {
      messaging = getMessaging(app);
      return messaging;
    } catch (_) {
      return null;
    }
  }

  return null;
};

export { app, initializeMessaging };
export type { Messaging } from 'firebase/messaging';
